/* eslint-disable array-callback-return */
import {
  cloneDeep,
  isArray,
  map,
  mapKeys,
  camelCase,
  snakeCase,
  mapValues,
  isPlainObject,
  isString,
  isNumber
} from 'lodash'
import VMasker from 'vanilla-masker'

export const TYPES_TO_CASE_FUNCTION = {
  snake: snakeCase,
  camel: camelCase
}

export const transformCase = (type, data) => {
  let dataObjt = cloneDeep(data)

  if (isNumber(dataObjt)) return dataObjt

  if (isString(dataObjt)) return dataObjt

  if (isArray(dataObjt))
    return map(dataObjt, (item) => transformCase(type, item))

  dataObjt = mapKeys(dataObjt, (value, key) =>
    TYPES_TO_CASE_FUNCTION[type](key)
  )

  // Recursively apply throughout object
  return mapValues(dataObjt, (value) => {
    if (isPlainObject(value)) return transformCase(type, value)

    if (isArray(value)) return map(value, (item) => transformCase(type, item))

    return value
  })
}

export const toCamelCase = (data) => transformCase('camel', data)
export const toSnakeCase = (data) => transformCase('snake', data)

export const removeSpacesTranformField = (value) =>
  String(value).replace(/\s/g, '')

export const toNumber = (data) => VMasker.toNumber(data)

export const transformToQuery = (queries) => {
  let query = ''

  Object.keys(queries)
    // eslint-disable-next-line no-unused-vars
    .forEach((name, i) => {
      const value = queries[name]

      if (Array.isArray(value)) {
        value.map((item) => {
          const separete = '&'

          query += `${separete}${name}[]=${encodeURIComponent(item)}`
        })
      } else if (value) {
        const separete = '&'

        query += `${separete}${name}=${value}`
      }
    })

  return query
}
